module.exports = __webpack_public_path__ + "static/img/403.81bcef2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/191007/403.jpg
// module id = 02Dz
// module chunks = 0